import React from 'react'

const norm = "lg:text-xl md:text-lg text-base"
const big = "lg:text-2xl md:text-xl text-lg"

const Heading = (props: { text: string, big?: boolean }) => {
    return (
        <div className="text-center w-full flex gap-4 text-white items-center my-6">
            <hr className='h-[5px] border-none bg-black w-full' />
            <span className={`text-lg p-2 text-center outline-3 outline-black bg-black outline outline-offset-8 w-fit md:min-w-[30vw] min-w-[60vw] px-4 ${props.big ? big : norm}`}>{props.text}</span>
            <hr className='h-[5px] border-none bg-black w-full' />
        </div>
    )
}

export default Heading